import React, { useState } from "react";
import TextareaAutosize from "react-autosize-textarea";
import style from "./Item.css";
import { SVGButton, Flex, MarkdownEditor } from "/app/src/component";

const ItemEditor = ({ toNormal, saveToDB, ...props }) => {
  const [title, setTitle] = useState(props.title);
  const [body, setBody] = useState(props.body);

  return (
    <Flex>
      <Flex column grow height="100%" padding="10px 0 10px 34px" color="black">
        <Flex column grow>
          <Flex className={style.FAQItemQuestionTextArea}>
            <TextareaAutosize
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Flex>
          <Flex height="200px">
            <MarkdownEditor text={body} onTextChange={setBody} />
          </Flex>
        </Flex>
      </Flex>

      <Flex hAlignContent="right" basis="150px" paddingRight="20px">
        <Flex className={style.FAQItemOptions} column center>
          <SVGButton
            onClick={(e) => {
              saveToDB(title, body);
            }}
            src="/images/Save.svg"
            color="darkgrey"
            hover="blue"
          >
            Spara
          </SVGButton>
          <SVGButton
            onClick={toNormal}
            src="/images/Return.svg"
            color="darkgrey"
            hover="blue"
          >
            Tillbaka
          </SVGButton>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ItemEditor;




// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/Item/ItemEditorView.jsx